import { useQuery, useQueryClient, useMutation } from '@tanstack/vue-query';
import { Message } from 'element-ui';

import { getSkipPage } from '@/utils/getSkipPage';
import { orderService } from '.';
import getMessageError from '@/utils/getMessageError';
import { toast } from '@/utils/programaticToast';
import { getToastContentComponent } from '@/utils/getToastContentComponent';

export function useCreateOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => orderService.create(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      toast.open({
        variant: 'success',
        position: 'bottom',
        component: getToastContentComponent({ title: 'Criado com sucesso', describe: 'Ordem foi criada com sucesso em nosso sistema', typeIcon: 'success' }),
        closable: true,
        duration: 4000
      });
    },
    onError: (error) => {
      toast.open({
        variant: 'error',
        position: 'bottom',
        component: getToastContentComponent({ title: 'Ocorreu um erro', describe: getMessageError(error), typeIcon: 'error' }),
        closable: true,
        duration: 4000
      });
    }
  });
}

export function useGetAllOrders(queryParams) {
  return useQuery({
    queryKey: ['orders', queryParams],
    queryFn: async() => {
      try {
        const { currentPage, perPage, currentDate } = queryParams.value;
        const skip = getSkipPage(currentPage);

        const res = await orderService.getAll(skip, perPage, currentDate);

        return res;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          return [];
        }

        throw error;
      }
    }
  });
}
